import { useState, useEffect } from "react";

function useScreenSize() {
  const isMobileOS = /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  function getCurrentDimension() {
    if (isMobileOS) {

      const isPortrait = window.innerHeight > window.innerWidth
      const longSide = Math.max(window.screen.width, window.screen.height);
      const shortSide = Math.min(window.screen.width, window.screen.height);
      return {
        width: isPortrait ? shortSide : longSide,
        height: isPortrait ? longSide : shortSide,
      };
    }
    return {
      width: window.innerWidth,
      height: window.innerHeight,
    };
  }

  // const cachedScreenSize = sessionStorage.getItem("screenSize");
  // const initialScreenSize = cachedScreenSize
  //   ? JSON.parse(cachedScreenSize)
  //   : getCurrentDimension();

  const [screenSize, setScreenSize] = useState(getCurrentDimension());

  useEffect(() => {
    let timeoutId: ReturnType<typeof setTimeout>;

    const updateDimension = () => {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        const newScreenSize = getCurrentDimension();

        setScreenSize(newScreenSize);
        sessionStorage.setItem("screenSize", JSON.stringify(newScreenSize));
      }, 300);
    };

    if (isMobileOS) {
      window.addEventListener("orientationchange", updateDimension);
      window.screen.orientation?.addEventListener("change", updateDimension);
    } else if (screenSize.width > 768) {
      window.addEventListener("resize", updateDimension);
    }

    return () => {
      clearTimeout(timeoutId);
      window.removeEventListener("orientationchange", updateDimension);
      window.screen.orientation?.removeEventListener("change", updateDimension);
      window.removeEventListener("resize", updateDimension);
    };
  }, []);

  return screenSize;
}

export default useScreenSize;